import { OfflineConstants } from '../offline/constants';
import { deleteStoreItem, getAllStoreItems, getStoreItem, getStoreKeys, putStoreItem } from '../offline/offlineApi';

export const getAolItem = async (key) => await getStoreItem(OfflineConstants.stores.aol.storeName, key);
export const getAllAolItems = async () => await getAllStoreItems(OfflineConstants.stores.aol.storeName);
export const putAolItem = async (storeItem, key) => await putStoreItem(OfflineConstants.stores.aol.storeName, storeItem, key);
export const deleteAolItem = async (key) => await deleteStoreItem(OfflineConstants.stores.aol.storeName, key);
export const getAolKeys = async () => await getStoreKeys(OfflineConstants.stores.aol.storeName);
